/**
 * mulberry32: a tiny seeded PRNG, so a shift is the same every time from the
 * same seed (tests, replays). Takes the current state and returns a number in
 * [0, 1) and the next state.
 */
export function nextRandom(state: number): [number, number] {
  const next = (state + 0x6d2b79f5) | 0;
  let t = next;
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  return [((t ^ (t >>> 14)) >>> 0) / 4294967296, next];
}
